'use client';
import classNames from 'classnames/bind';
import React, { forwardRef } from 'react';
import CommonHeader from './CommonHeader.mjs';
import Divider from './Divider.mjs';
import HeaderName from './HeaderName.mjs';
import { HeaderNPayMonoButton } from './HeaderNpayButton.mjs';
import { NF_HEADER_TYPE } from '../../constants/global.mjs';
import useApplyLogging from '../../hooks/useApplyLogging.mjs';
import useHeaderBrandLogo from '../../hooks/useHeaderBrandLogo.mjs';
import styles from './HeaderBrandDepth.module.scss.mjs';

const cx = classNames.bind(styles);
/**
 * 서비스별 1-depth 헤더
 */
const HeaderBrandDepth = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    serviceType = 'none',
    serviceTypeRef,
    subTitle,
    rightComponent,
    bgColor = 'white',
    brandLogo = {},
    href,
    isPayApp,
    children,
    ...props
  } = _ref;
  useApplyLogging('HeaderBrandDepth');
  const {
    href: subTitleHref,
    text: subTitleText,
    blindText: subTitleBlindText,
    ...subTitleProps
  } = subTitle;
  const {
    npayLogo
  } = useHeaderBrandLogo(brandLogo);
  const hasParentService = serviceType !== 'none';
  return /*#__PURE__*/React.createElement(CommonHeader, {
    align: "left",
    bgColor: bgColor,
    rightComponent: rightComponent,
    ref: ref
  }, /*#__PURE__*/React.createElement("h1", null, /*#__PURE__*/React.createElement(HeaderNPayMonoButton, {
    isPayApp: isPayApp,
    ...npayLogo
  }), hasParentService && ( /*#__PURE__*/React.createElement(HeaderName, {
    serviceType: serviceType,
    headerType: NF_HEADER_TYPE.DEPTH,
    href: href,
    ...props,
    ref: serviceTypeRef
  }))), hasParentService && /*#__PURE__*/React.createElement(Divider, null), /*#__PURE__*/React.createElement("h2", {
    className: cx('area-sub-name', {
      'margin-type': !hasParentService
    })
  }, /*#__PURE__*/React.createElement("a", {
    ...subTitleProps,
    href: subTitleHref,
    className: cx('sub-name')
  }, subTitleText, subTitleBlindText && /*#__PURE__*/React.createElement("span", {
    className: "blind"
  }, subTitleBlindText)), children));
});
HeaderBrandDepth.displayName = 'HeaderBrandDepth';

export { HeaderBrandDepth as default };
